import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instanceldqbxvjihuns as Companion_instance } from './Optional.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CustomScalarTypeClass;
function CustomScalarType() {
  if (CustomScalarTypeClass === VOID) {
    class $ extends CompiledNamedType() {
      constructor(name, className) {
        super(name);
        this.x45_1 = className;
      }
    }
    initMetadataForClass($, 'CustomScalarType');
    CustomScalarTypeClass = $;
  }
  return CustomScalarTypeClass;
}
var CompiledNamedTypeClass;
function CompiledNamedType() {
  if (CompiledNamedTypeClass === VOID) {
    class $ extends CompiledType() {
      constructor(name) {
        super();
        this.y45_1 = name;
      }
    }
    initMetadataForClass($, 'CompiledNamedType');
    CompiledNamedTypeClass = $;
  }
  return CompiledNamedTypeClass;
}
var CompiledTypeClass;
function CompiledType() {
  if (CompiledTypeClass === VOID) {
    class $ {}
    initMetadataForClass($, 'CompiledType');
    CompiledTypeClass = $;
  }
  return CompiledTypeClass;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(name, type) {
        this.z45_1 = name;
        this.a46_1 = type;
        this.b46_1 = null;
        this.c46_1 = emptyList();
        this.d46_1 = emptyList();
        this.e46_1 = emptyList();
      }
      f46(arguments_0) {
        // Inline function 'kotlin.apply' call
        this.d46_1 = arguments_0;
        return this;
      }
      g46(selections) {
        // Inline function 'kotlin.apply' call
        this.e46_1 = selections;
        return this;
      }
      v39() {
        var tmp0_name = this.z45_1;
        var tmp1_alias = this.b46_1;
        var tmp2_type = this.a46_1;
        var tmp3_condition = this.c46_1;
        var tmp4_arguments = this.d46_1;
        var tmp5_selections = this.e46_1;
        return new (CompiledField())(tmp0_name, tmp2_type, tmp1_alias, tmp3_condition, tmp4_arguments, tmp5_selections);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var CompiledFieldClass;
function CompiledField() {
  if (CompiledFieldClass === VOID) {
    class $ extends CompiledSelection() {
      constructor(name, type, alias, condition, arguments_0, selections) {
        super();
        this.h46_1 = name;
        this.i46_1 = type;
        this.j46_1 = alias;
        this.k46_1 = condition;
        this.l46_1 = arguments_0;
        this.m46_1 = selections;
      }
    }
    initMetadataForClass($, 'CompiledField');
    CompiledFieldClass = $;
  }
  return CompiledFieldClass;
}
var CompiledSelectionClass;
function CompiledSelection() {
  if (CompiledSelectionClass === VOID) {
    class $ {}
    initMetadataForClass($, 'CompiledSelection');
    CompiledSelectionClass = $;
  }
  return CompiledSelectionClass;
}
var BuilderClass_0;
function Builder_0() {
  if (BuilderClass_0 === VOID) {
    class $ {
      constructor(definition) {
        this.n46_1 = definition;
        this.o46_1 = Companion_instance.p46();
      }
      q46(value) {
        // Inline function 'kotlin.apply' call
        this.o46_1 = Companion_instance.r46(value);
        return this;
      }
      v39() {
        return new (CompiledArgument())(this.n46_1, this.o46_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_0 = $;
  }
  return BuilderClass_0;
}
var CompiledArgumentClass;
function CompiledArgument() {
  if (CompiledArgumentClass === VOID) {
    class $ {
      constructor(definition, value) {
        this.s46_1 = definition;
        this.t46_1 = value;
      }
    }
    initMetadataForClass($, 'CompiledArgument');
    CompiledArgumentClass = $;
  }
  return CompiledArgumentClass;
}
var BuilderClass_1;
function Builder_1() {
  if (BuilderClass_1 === VOID) {
    class $ {
      constructor(name) {
        this.u46_1 = name;
        this.v46_1 = false;
      }
      v39() {
        return new (CompiledArgumentDefinition())(this.u46_1, this.v46_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_1 = $;
  }
  return BuilderClass_1;
}
var CompiledArgumentDefinitionClass;
function CompiledArgumentDefinition() {
  if (CompiledArgumentDefinitionClass === VOID) {
    class $ {
      constructor(name, isKey) {
        this.w46_1 = name;
        this.x46_1 = isKey;
        this.y46_1 = false;
      }
    }
    initMetadataForClass($, 'CompiledArgumentDefinition');
    CompiledArgumentDefinitionClass = $;
  }
  return CompiledArgumentDefinitionClass;
}
var CompiledVariableClass;
function CompiledVariable() {
  if (CompiledVariableClass === VOID) {
    class $ {
      constructor(name) {
        this.z46_1 = name;
      }
    }
    initMetadataForClass($, 'CompiledVariable');
    CompiledVariableClass = $;
  }
  return CompiledVariableClass;
}
var BuilderClass_2;
function Builder_2() {
  if (BuilderClass_2 === VOID) {
    class $ {
      constructor(name) {
        this.a47_1 = name;
        this.b47_1 = emptyList();
        this.c47_1 = emptyList();
      }
      v39() {
        return new (ObjectType())(this.a47_1, this.b47_1, this.c47_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_2 = $;
  }
  return BuilderClass_2;
}
var ObjectTypeClass;
function ObjectType() {
  if (ObjectTypeClass === VOID) {
    class $ extends CompiledNamedType() {
      constructor(name, keyFields, implements_0) {
        super(name);
        this.e47_1 = keyFields;
        this.f47_1 = implements_0;
        this.g47_1 = emptyList();
      }
    }
    initMetadataForClass($, 'ObjectType');
    ObjectTypeClass = $;
  }
  return ObjectTypeClass;
}
var CompiledNotNullTypeClass;
function CompiledNotNullType() {
  if (CompiledNotNullTypeClass === VOID) {
    class $ extends CompiledType() {
      constructor(ofType) {
        super();
        this.h47_1 = ofType;
      }
    }
    initMetadataForClass($, 'CompiledNotNullType');
    CompiledNotNullTypeClass = $;
  }
  return CompiledNotNullTypeClass;
}
function notNull(_this__u8e3s4) {
  return new (CompiledNotNullType())(_this__u8e3s4);
}
var CompiledListTypeClass;
function CompiledListType() {
  if (CompiledListTypeClass === VOID) {
    class $ extends CompiledType() {
      constructor(ofType) {
        super();
        this.i47_1 = ofType;
      }
    }
    initMetadataForClass($, 'CompiledListType');
    CompiledListTypeClass = $;
  }
  return CompiledListTypeClass;
}
function list(_this__u8e3s4) {
  return new (CompiledListType())(_this__u8e3s4);
}
var BuilderClass_3;
function Builder_3() {
  if (BuilderClass_3 === VOID) {
    class $ {
      constructor(typeCondition, possibleTypesSet) {
        this.j47_1 = typeCondition;
        this.k47_1 = possibleTypesSet;
        this.l47_1 = emptyList();
        this.m47_1 = emptyList();
      }
      g46(selections) {
        // Inline function 'kotlin.apply' call
        this.m47_1 = selections;
        return this;
      }
      v39() {
        return new (CompiledFragment())(this.j47_1, this.k47_1, this.l47_1, this.m47_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_3 = $;
  }
  return BuilderClass_3;
}
var CompiledFragmentClass;
function CompiledFragment() {
  if (CompiledFragmentClass === VOID) {
    class $ extends CompiledSelection() {
      constructor(typeCondition, possibleTypesSet, condition, selections) {
        super();
        this.n47_1 = typeCondition;
        this.o47_1 = possibleTypesSet;
        this.p47_1 = condition;
        this.q47_1 = selections;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.r47_1 = lazy(tmp_0, () => toList(this.o47_1));
      }
    }
    initMetadataForClass($, 'CompiledFragment');
    CompiledFragmentClass = $;
  }
  return CompiledFragmentClass;
}
var EnumTypeClass;
function EnumType() {
  if (EnumTypeClass === VOID) {
    class $ extends CompiledNamedType() {
      constructor(name, values) {
        super(name);
        this.t47_1 = values;
      }
    }
    initMetadataForClass($, 'EnumType');
    EnumTypeClass = $;
  }
  return EnumTypeClass;
}
//region block: exports
export {
  Builder_0 as Builder3t31vflw4km89,
  Builder_1 as Builderlyags3ldja2y,
  Builder as Builder320ghmibyd2no,
  Builder_3 as Builder2iaenv1j4gk4w,
  CompiledVariable as CompiledVariablecaz6ndkw7us2,
  CustomScalarType as CustomScalarType8w7iuefxipic,
  EnumType as EnumType11cgb4df0n5r9,
  Builder_2 as Builder3vv3qt9kyowg0,
  list as lista11lrkbcitk,
  notNull as notNull3hndh47e9bowl,
};
//endregion

//# sourceMappingURL=CompiledGraphQL.mjs.map
